module.exports = __webpack_public_path__ + "media/images/ibu__icon__language-da385a47ad4e0360a93f34328f8e298b.svg";